var prefixChannel = function (prefix, keyword) { return prefix + "." + keyword; };
var BetslipUtilPrefixChannel = function (x) { return prefixChannel("BsUtilChannels", x); };
/**
 * @namespace
 * @property {object} Broadcast                     - channel for broadcasting messages
 * @property {string} Broadcast.Status              - channel for broadcasting Status messages
 * @property {object} Broadcast.Items               - channel for broadcasting messages for Items
 * @property {string} Broadcast.Items.added         - channel for broadcasting messages for added Items
 * @property {string} Broadcast.Items.removed       - channel for broadcasting messages for removed Items
 * @property {string} Broadcast.Items.cleared       - channel for broadcasting messages for cleared Items
 * @property {object} Listen                        - channel for receiving messages
 * @property {object} Listen.Commands               - channel for receiving messages for Commands
 * @property {string} Listen.Commands.add_items     - channel for receiving messages for add_items Command
 * @property {string} Listen.Commands.remove_items  - channel for receiving messages for remove_items Command
 * @property {string} Listen.Commands.get_status    - channel for receiving messages for get_status Command
 * @property {string} Listen.Commands.clear_slip    - channel for receiving messages for clear_slip Command
 */
export var BetslipUtilChannels = {
    Broadcast: {
        Status: BetslipUtilPrefixChannel("broadcast.status"),
        Items: {
            added: BetslipUtilPrefixChannel("broadcast.items.added"),
            removed: BetslipUtilPrefixChannel("broadcast.items.removed"),
            cleared: BetslipUtilPrefixChannel("broadcast.items.cleared")
        },
    },
    Listen: {
        Commands: {
            add_items: BetslipUtilPrefixChannel("listen.commands.add_items"),
            remove_items: BetslipUtilPrefixChannel("listen.commands.remove_items"),
            get_status: BetslipUtilPrefixChannel("listen.commands.get_status"),
            clear_slip: BetslipUtilPrefixChannel("listen.commands.clear_slip")
        }
    }
};
//# sourceMappingURL=constants.js.map